import { useState, useEffect, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, fmtError } from "@/lib/api";
import { AuthShell } from "@/components/AuthShell";
import { Loader2, MailCheck, MailX } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState("verifying");
  const [error, setError] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    if (!token) { setState("error"); setError("Missing verification token."); return; }
    api.post("/auth/verify-email", { token })
      .then(() => setState("done"))
      .catch((err) => { setState("error"); setError(fmtError(err.response?.data?.detail) || err.message); });
  }, [token]);

  return (
    <AuthShell title="Email verification" subtitle="Confirming your HumNest account.">
      <div className="ll-fade-up flex flex-col items-center text-center gap-4 py-4" data-testid="verify-email-screen">
        {state === "verifying" && <><Loader2 className="w-12 h-12 text-[#F97316] animate-spin" /><p className="text-[#111827]/70">Verifying your email…</p></>}
        {state === "done" && <><MailCheck className="w-14 h-14 text-[#16A34A]" data-testid="verify-email-success" /><p className="text-[#111827]/70">Your email is verified. You're all set.</p></>}
        {state === "error" && <><MailX className="w-14 h-14 text-[#DC2626]" data-testid="verify-email-error" /><p className="text-[#111827]/70">{error}</p></>}
        <Link to="/auth/sign-in" data-testid="verify-email-back" className="w-full bg-[#F97316] text-white rounded-2xl py-4 font-bold min-h-[56px] flex items-center justify-center">Go to Sign In</Link>
      </div>
    </AuthShell>
  );
}
